<div class="banner justify-content-center" role="banner">
  <h1 class="text-white">{{ 'offers.page.title' | translate }}</h1>
</div>

<fgb-endurance-zone></fgb-endurance-zone>
